import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";

/**
 * Moves focus to the step heading when the active step changes.
 * This ensures keyboard and screen reader users are oriented to the
 * new content after a step transition, rather than losing focus position.
 *
 * Targets `h1` elements inside `[data-step-content]` and sets
 * `tabIndex={-1}` so they are programmatically focusable but not
 * added to the tab order.
 */
export function useStepFocusManagement(stepIndex) {
  const $ = _c(3);
  const previousStep = useRef(stepIndex);
  let t0;
  let t1;
  if ($[0] !== stepIndex) {
    t0 = () => {
      if (previousStep.current !== stepIndex) {
        previousStep.current = stepIndex;
        requestAnimationFrame(_temp);
      }
    };
    t1 = [stepIndex];
    $[0] = stepIndex;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}
function _temp() {
  const heading = document.querySelector("[data-step-content] h1");
  if (heading) {
    heading.tabIndex = -1;
    heading.focus({
      preventScroll: false
    });
  }
}